import React from 'react';
import { Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white shadow-md mt-8">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-600 text-center sm:text-left">
            Наступны прыпынак — прырода.
          </p>
          <div className="flex items-center gap-2 text-gray-600">
            <Mail size={18} className="text-primary" />
            <a 
              href="mailto:contact@moikutok.by"
              className="hover:text-primary transition-colors"
            >
              contact@moikutok.by
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};